import React, { useState } from 'react';
import { Alert, Button, Box, IconButton, Collapse, LinearProgress, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import TimerIcon from '@mui/icons-material/Timer';
import api from '../api';

export default function TrialCountdownBanner({ subscriptionStatus, trialEnd }) {
  const [open, setOpen] = useState(true);
  const [portalLoading, setPortalLoading] = useState(false);

  if (subscriptionStatus !== 'trialing' || !trialEnd) return null;

  const trialEndDate = new Date(trialEnd);
  const now = new Date();
  const daysLeft = Math.ceil((trialEndDate - now) / (1000 * 60 * 60 * 24));

  // Only show when 7 or fewer days remain
  if (daysLeft > 7) return null;

  const urgency = daysLeft <= 2 ? 'error' : daysLeft <= 4 ? 'warning' : 'info';
  const progress = Math.max(0, Math.min(100, (daysLeft / 14) * 100));

  const handleAddPayment = async () => {
    setPortalLoading(true);
    try {
      const res = await api.get('/api/platform/subscription/portal/');
      if (res.data?.url) window.open(res.data.url, '_blank');
    } catch (err) {
      console.error('Failed to open billing portal', err);
    } finally {
      setPortalLoading(false);
    }
  };

  return (
    <Collapse in={open}>
      <Alert
        severity={urgency}
        icon={<TimerIcon />}
        sx={{
          borderRadius: 0,
          position: 'sticky',
          top: 0,
          zIndex: 1300,
          '& .MuiAlert-message': { display: 'flex', alignItems: 'center', gap: 2, width: '100%', flexWrap: 'wrap' }
        }}
        action={
          <IconButton size="small" onClick={() => setOpen(false)}>
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      >
        <Box sx={{ flexGrow: 1 }}>
          <Typography variant="body2" fontWeight={600}>
            {daysLeft <= 0
              ? 'Your free trial has ended. Add a payment method to continue.'
              : `Your free trial ends in ${daysLeft} day${daysLeft === 1 ? '' : 's'}. Add a payment method to continue.`}
          </Typography>
          <LinearProgress
            variant="determinate"
            value={progress}
            color={urgency}
            sx={{ mt: 0.5, height: 4, borderRadius: 2 }}
          />
        </Box>
        <Button
          size="small"
          variant="contained"
          color={urgency}
          onClick={handleAddPayment}
          disabled={portalLoading}
          sx={{ fontWeight: 700, whiteSpace: 'nowrap' }}
        >
          Add Payment Method
        </Button>
      </Alert>
    </Collapse>
  );
}
